import { updateClinic } from '@app/api/clinic';
import { Box, List, ListItem, Switch, Typography } from '@mui/material';
import React from 'react';
import { IClinic } from '@app/interfaces/clinic.interface';

type Props = {
  clinic: IClinic;
  setClinic: (clinic: IClinic) => void;
};

function QrCodeToggler({ clinic, setClinic }: Props) {
  const handleToggle = async () => {
    const res = await updateClinic({ ...clinic, isQrCode: !clinic.isQrCode });

    setClinic(res.data);
  };

  return (
    <Box>
      <Typography variant='h6'>QR Code:</Typography>

      <List dense={true}>
        <ListItem disablePadding>
          <Switch
            edge='start'
            onChange={handleToggle}
            checked={clinic.isQrCode}
            sx={{ marginRight: 2 }}
            disabled={false}
            color='success'
          />
        </ListItem>
      </List>
    </Box>
  );
}

export default QrCodeToggler;
